<template>
  <div>
    <new-competence-popup
      :data-to-show="isNewCompetencePopupDisplayed"
      @close="changeStateNewCompetencePopup(false)"
      @addCompetence="
        (newValue) => {
          addNewCompetence(newValue, 'Autres');
        }
      "
      :limit="hasLimit ? 40 : null"
    />

    <new-competence-metier-popup
      :data-to-show="isNewCompetenceMetierPopupDisplayed"
      @close="changeStateNewCompetenceMetierPopup(false)"
      @addCompetence="
        (newValue) => {
          addNewCompetence(newValue.list, newValue.metier);
        }
      "
    />

    <h3 class="my-15">
      Compétences
    </h3>

    <div v-show="!hasCompetences">
      <h6 class="mx-15 text-gray-600">
        Aucune compétence n'a été renseignée sur votre Neopass.
      </h6>
      <h6 class="mx-15 text-gray-600 mt-5">
        Pour mettre en avant vos compétences, cliquer sur le bouton "ajouter une
        nouvelle compétence"
      </h6>

      <p class="text-center text-base mt-10">
        Ajouter une nouvelle compétence :
      </p>
      <div
        class="flex flex-col lg:flex-row justify-center space-y-2 lg:space-x-2 mt-5 items-center"
      >
        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-indigo-600"
          bg-color-square="bg-indigo-600"
          icon-color="text-white"
          libelle="manuellement"
          :uppercase="true"
          icon="plus-circle"
          type-shadow="indigo-shadow"
          @clickAction="changeStateNewCompetencePopup(true)"
        />
        <p>ou</p>
        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-indigo-600"
          bg-color-square="bg-indigo-600"
          icon-color="text-white"
          libelle="liée à un métier"
          :uppercase="true"
          icon="plus-circle"
          type-shadow="indigo-shadow"
          @clickAction="changeStateNewCompetenceMetierPopup(true)"
        />
      </div>

      <div class="flex justify-center mt-10">
        <illustration name="evaluation" />
      </div>
    </div>

    <div v-show="hasCompetences">
      <div class="relative w-max">
        <add-button
          class="mb-8 mx-10"
          libelle="Ajouter une nouvelle compétence"
          :with-dropdown="true"
          @add="displayMenuNewComp"
        />

        <div
          v-if="isMenuNewCompDisplayed"
          class="absolute z-10 right-0 top-8 px-5 py-3 bg-white shadow rounded-xl text-sm"
          v-click-outside="displayMenuNewComp"
        >
          <div class="flex flex-col space-y-1.5 text-gray-600">
            <p
              class="hover:text-gray-900 cursor-pointer"
              @click.stop="changeStateNewCompetenceMetierPopup(true)"
            >
              Ajouter une compétence liée à un métier
            </p>
            <p
              class="hover:text-gray-900 cursor-pointer"
              @click.stop="changeStateNewCompetencePopup(true)"
            >
              Ajouter une compétence manuellement
            </p>
          </div>
        </div>
      </div>

      <!-- BEGIN list competences and updated competences from CV datas -->
      <div
        v-for="(list, metier) in competences"
        :key="'competences' + metier"
        class="p-0 odd:bg-gray-200 odd:bg-opacity-50"
      >
        <div
          @click="displayMetier(metier)"
          class="py-5 grid grid-cols-12 gap-x-4 items-center min-h-20 cursor-default hover:bg-indigo-200"
          :class="{
            'bg-indigo-200 border-l-2 border-indigo-600':
              metierToDisplay === metier,
          }"
        >
          <div class="col-span-2 justify-self-center handle">
            <icon
              name="chevron-right"
              class="text-pink-600 h-3 transform transition-all duration-200"
              :class="{
                'rotate-90': metierToDisplay === metier,
              }"
            />
          </div>
          <div class="col-span-6 grid grid-cols-12 items-center">
            <div class="col-span-2">
              <CVNewValue
                v-if="
                  changedCompetences.includes(metier) &&
                    newer.data.competences[metier]
                "
                :old="newer.data.competences[metier].map((c) => c.value)"
                @change="
                  (newValue) => {
                    replaceValues(metier);
                  }
                "
                :right="false"
              />
            </div>
            <div class="col-span-10">
              <p class="text-base">
                {{ metier }}
              </p>
            </div>
          </div>
          <div class="col-span-4 flex space-x-3">
            <p class="text-base italic font-light">
              {{ list.length }} compétences
            </p>
          </div>
        </div>
        <transition-group
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            v-show="metierToDisplay === metier"
            class="bg-white px-10 py-5"
            :key="'metier' + metier"
          >
            <div
              v-if="isErrorMaxLengthDisplayed"
              class="text-pink-600 text-base text-center mb-8"
            >
              Il n'y a pas assez de place pour afficher cette compétence.
            </div>
            <div
              v-if="isErrorMinLengthDisplayed"
              class="text-pink-600 text-base text-center mb-8"
            >
              Afin d'avoir un rendu visuel optimal, il faut afficher entre 3 et
              5 lignes.
            </div>
            <div v-if="!list.every((comp) => comp.value)">
              Veuillez compléter cette compétence via la page "Parcours" de votre carnet de parcours.
            </div>
            <div class=" ">
              <draggable
                v-model="form.data.competences[metier]"
                v-bind="dragOptions"
                @end="drag = false"
                @start="drag = true"
              >
                <transition-group
                  enter-active-class="ease-in duration-1000"
                  enter-class="bg-indigo-300 border-0 rounded-xl"
                  enter-to-class="bg-none border-0 rounded-xl"
                  leave-active-class="linear duration-1000"
                  leave-class="h-20 opacity-100"
                  leave-to-class="h-0 opacity-0"
                  tag="div"
                  class="grid grid-cols-1 md:grid-cols-3 gap-3"
                >
                  <div
                    v-for="(competence, kc) in list"
                    :key="'comp' + kc"
                    class="col-span-1"
                  >
                    <tag
                      @push="displayCompetence(metier, kc)"
                      @close="removeCompetence(metier, kc)"
                      class="cursor-pointer"
                      :theme-color="
                        competence.isDisplayed ? 'indigo-2' : 'white'
                      "
                      :libelle="competence.value"
                      text-size="text-sm"
                      text-font="font-light"
                      :icon="
                        competence.isDisplayed ? 'minus-circle' : 'plus-circle'
                      "
                      :icon-color="
                        competence.isDisplayed
                          ? 'text-indigo-600'
                          : 'text-gray-600'
                      "
                      icon-size="w-4 h-4"
                      :can-truncate="true"
                      :scale-on-hover="true"
                      :is-closeable="true"
                    />
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </transition-group>
      </div>
      <!-- END list competences and updated competences from CV datas -->

      <!-- BEGIN list new competences in Neopass -->
      <div
        v-for="(list, metier) in newCompetences"
        :key="'competences' + metier"
        class="p-0 odd:bg-gray-200 odd:bg-opacity-25"
      >
        <div
          @click="displayMetier(metier)"
          class="py-5 grid grid-cols-12 gap-x-4 items-center h-20 cursor-default hover:bg-indigo-200"
          :class="{
            'bg-indigo-200 border-l-2 border-indigo-600':
              metierToDisplay === metier,
          }"
        >
          <div class="col-span-2 justify-self-center handle opacity-25">
            <icon
              name="chevron-right"
              class="text-pink-600 h-3 transform transition-all duration-200"
              :class="{
                'rotate-90': metierToDisplay === metier,
              }"
            />
          </div>
          <div class="col-span-6">
            <div class="grid grid-cols-12">
              <div class="col-span-2">
                <CVNewValue
                  :old="newCompetences[metier].map((c) => c.value)"
                  @addNew="
                    (newValue) => {
                      importFromNeopass(metier);
                    }
                  "
                  :right="false"
                  :is-new="true"
                />
              </div>
              <div class="col-span-10 opacity-25">
                <p class="text-base">
                  {{ metier }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-span-4 flex space-x-3 opacity-25">
            <p class="text-base italic font-light">
              {{ list.length }} compétences
            </p>
          </div>
        </div>
        <transition-group
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            v-show="metierToDisplay === metier"
            class="bg-white px-10 py-5"
            :key="'metier' + metier"
          >
            <div
              v-if="isErrorMaxLengthDisplayed"
              class="text-pink-600 text-base text-center mb-8"
            >
              Il n'y a pas assez de place pour afficher cette compétence.
            </div>
            <div
              v-if="isErrorMinLengthDisplayed"
              class="text-pink-600 text-base text-center mb-8"
            >
              Afin d'avoir un rendu visuel optimal, il faut afficher entre 3 et
              5 lignes.
            </div>
            <div class=" ">
              <draggable
                v-model="form.data.competences[metier]"
                v-bind="dragOptions"
                @end="drag = false"
                @start="drag = true"
              >
                <transition-group
                  enter-active-class="ease-in duration-1000"
                  enter-class="bg-indigo-300 border-0 rounded-xl"
                  enter-to-class="bg-none border-0 rounded-xl"
                  leave-active-class="linear duration-1000"
                  leave-class="h-20 opacity-100"
                  leave-to-class="h-0 opacity-0"
                  tag="div"
                  class="grid grid-cols-1 md:grid-cols-3 gap-3"
                >
                  <div
                    v-for="(competence, kc) in list"
                    :key="'comp' + kc"
                    class="col-span-1"
                  >
                    <tag
                      @push="displayCompetence(metier, kc)"
                      class="cursor-pointer"
                      :theme-color="
                        competence.isDisplayed ? 'indigo-2' : 'white'
                      "
                      :libelle="competence.value"
                      text-size="text-sm"
                      text-font="font-light"
                      :icon="
                        competence.isDisplayed ? 'minus-circle' : 'plus-circle'
                      "
                      :icon-color="
                        competence.isDisplayed
                          ? 'text-indigo-600'
                          : 'text-gray-600'
                      "
                      icon-size="w-4 h-4"
                      :can-truncate="true"
                      :scale-on-hover="true"
                    />
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </transition-group>
      </div>
      <!-- END list new competences in Neopass -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import ClickOutside from 'vue-click-outside';

import AddButton from './../../../components/Inputs/AddButton.vue';
import Icon from './../../../components/Icon.vue';
import Tag from './../../../components/Tag.vue';
import NewCompetencePopup from './../popup/NewCompetencePopup.vue';
import NewCompetenceMetierPopup from './../popup/NewCompetenceMetierPopup.vue';
import CVNewValue from './CVNewValue';

import ActionButton from './../../../components/ActionButton.vue';
import Illustration from './../../../components/Illustration.vue';

import Constants from './../../../constants';

export default {
  components: {
    AddButton,
    Icon,
    Tag,
    NewCompetencePopup,
    draggable,
    NewCompetenceMetierPopup,
    ActionButton,
    Illustration,
    CVNewValue,
  },

  data() {
    return {
      isNewCompetencePopupDisplayed: false,
      isNewCompetenceMetierPopupDisplayed: false,
      metierToDisplay: '',
      isMenuNewCompDisplayed: false,
      isRefresh: false,
      isErrorMaxLengthDisplayed: false,
      isErrorMinLengthDisplayed: false,
      constants: Constants,
    };
  },

  methods: {
    ...mapActions({
      saveDatas: 'curriculumVitae/saveDatas',
    }),

    displayMetier(metier) {
      this.isErrorMaxLengthDisplayed = false;
      if (this.metierToDisplay === metier) {
        this.metierToDisplay = '';
        return;
      }

      this.metierToDisplay = metier;
    },

    changeStateNewCompetencePopup(state) {
      this.isNewCompetencePopupDisplayed = state;
    },

    changeStateNewCompetenceMetierPopup(state) {
      this.isNewCompetenceMetierPopupDisplayed = state;
    },

    addNewCompetence(listComp, metier = null) {
      let list =
        typeof listComp === 'string'
          ? listComp.split(',').map((w) => w.trim())
          : listComp;

      if (!this.form.data.competences[metier]) {
        this.form.data.competences[metier] = [];
      }
      list.forEach((comp) => {
        this.form.data.competences[metier].push({
          fromNeopass: false,
          isDisplayed:
            this.hasLimit && this.nbDisplayedCompetences >= 5 ? false : true,
          value: comp,
        });
      });
      this.saveDatas();
      this.$forceUpdate();

      this.isRefresh = true;
      setTimeout(() => {
        this.isRefresh = false;
      }, 2000);
    },

    removeCompetence(metier, index) {
      this.form.data.competences[metier].splice(index, 1);
    },

    displayCompetence(metierName, index) {
      this.displayedCompetences.forEach((cmp) => {
        console.log(Math.ceil(cmp.value.length / 25));
      });
      if (this.hasLimit) {
        let comp = this.form.data.competences[metierName][index];
        let compLength = Math.ceil(comp.value.length / 25);

        if (!this.form.data.competences[metierName][index].isDisplayed) {
          //Want to select comp
          var totalLength = this.nbDisplayedCompetences + compLength;

          if (totalLength > 5) {
            this.isErrorMaxLengthDisplayed = true;
            this.isErrorMinLengthDisplayed = false;
            return;
          }
          if (totalLength <= 5 && totalLength >= 3) {
            this.isErrorMaxLengthDisplayed = false;
            this.isErrorMinLengthDisplayed = false;
          }
        }
        if (this.form.data.competences[metierName][index].isDisplayed) {
          //Want to deselect comp
          var totalLength = this.nbDisplayedCompetences - compLength;

          if (totalLength <= 5 && totalLength < 3) {
            this.isErrorMaxLengthDisplayed = false;
            this.isErrorMinLengthDisplayed = true;
          }

          if (totalLength <= 5 && totalLength >= 3) {
            this.isErrorMaxLengthDisplayed = false;
            this.isErrorMinLengthDisplayed = false;
          }
        }
      }

      this.form.data.competences[metierName][index].isDisplayed =
        !this.form.data.competences[metierName][index].isDisplayed;

      this.$forceUpdate();
      this.saveDatas();
    },

    displayMenuNewComp() {
      this.isMenuNewCompDisplayed = !this.isMenuNewCompDisplayed;
    },

    replaceValues(metier) {
      this.form.data.competences[metier] = [
        ...this.form.data.competences[metier],
        ...this.newer.data.competences[metier],
      ];
      this.newer.data.competences[metier] = false;
      this.saveDatas();
      this.$forceUpdate();
    },

    importFromNeopass(metier) {
      this.form.data.competences[metier] = this.newCompetences[metier];

      delete this.newer.data.competences._newSkills[metier];

      this.saveDatas();
      this.$forceUpdate();
    },
  },

  computed: {
    ...mapGetters({
      form: 'curriculumVitae/form',
      newer: 'curriculumVitae/newForm',
      backdoor: 'app/backdoor',
    }),

    competences() {
      this.backdoor; //here value to reactivity
      let listComp = this.form.data.competences;

      //keep only "metier" with nb competences > 0
      return Object.keys(listComp)
        .filter((metier) => listComp[metier].length > 0)
        .reduce((res, key) => ((res[key] = listComp[key]), res), {});
    },

    newCompetences() {
      return this.newer.data.competences._newSkills
        ? this.newer.data.competences._newSkills
        : {};
    },

    changedCompetences() {
      return Object.keys(this.newer.data.competences);
    },

    dragOptions() {
      return {
        animation: 500,
      };
    },

    hasCompetences() {
      return (
        Object.values(this.competences).reduce(
          (previousValue, currentValue) => previousValue + currentValue.length,
          0
        ) > 0
      );
    },

    displayedCompetences() {
      this.backdoor; //for reactivity
      return [...new Set(Object.values(this.competences).flat())].filter(
        (cmp) => cmp.isDisplayed
      );
    },

    nbDisplayedCompetences() {
      //return this.displayedCompetences.length;
      return this.displayedCompetences.reduce(
        (acc, comp) => acc + Math.ceil(comp.value.length / 25),
        0
      );
    },

    /* nbCaractersDisplayedCompetences(){
            return this.displayedCompetences.join('').length;
        }, */

    hasLimit() {
      return [Constants.CV_TYPES.DASHBOARD].includes(this.form.type);
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
